// Share to social media in event pages
$(document).ready(function() {
  $('*[data-share]').unbind('click')
  $('*[data-share]').click(e => {
    e.preventDefault()
    e.stopPropagation()
    let target = e.currentTarget.getAttribute('data-share')
    let url = window.location.href.split('?')[0]
    let title = document.title
    let windowHeight = 350,
    windowWidth = 520,
    alignTop = screen.height / 2 - windowHeight / 2,
    alignLeft = screen.width / 2 - windowWidth / 2
    let descr = document
    .querySelector('meta[name=description]')
    .getAttribute('content')

    const openUrl = (url, close) => {
      const targetOpen = window.open(
        url,
        '',
        'top=' +
        alignTop +
        ',left=' +
        alignLeft +
        ',width=' +
        windowWidth +
        ',height=' +
        windowHeight
        )
    }

    if (target === 'facebook') {
      let targeturl = `https://www.facebook.com/sharer.php?s=100&p[title]=${title}&p[summary]=${descr}&p[url]=${url}`
      return openUrl(targeturl)
    } else if (target === 'twitter') {
      let targeturl = `https://twitter.com/share?url=${url}`
      return openUrl(targeturl)
    } else if (target === 'linkedin') {
      let targeturl = `https://www.linkedin.com/shareArticle?mini=true&url=${url}&title=${title}`
      return openUrl(targeturl)
    } else if (target === 'email') {
      targeturl = `mailto:?subject=${title}&body=${url}\n${descr}`
      return openUrl(targeturl, true)
    }
  })
})
